<template>
  <div v-if="srcImage === '' && !model.DefaultImage && isInEditorMode" class="dr-image_plug">
    <span>Image</span>
  </div>
  <v-img
    v-else-if="!needDefaultImage && srcImage"
    ref="drImage"
    :width="getDataSourceField(model.Width)"
    :height="getDataSourceField(model.Height)"
    :class="classes"
    :src="srcImage"
    @load="load"
    @error="error"
  />
  <v-img
    v-else
    :width="getDataSourceField(model.Width)"
    :height="getDataSourceField(model.Height)"
    :src="getDataSourceField(model.DefaultImage)"
    :class="classes"
  />
</template>

<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'

export default {
  name: 'dr-image-component',
  mixins: [mixin, inputMixin],
  data: () => ({
    needDefaultImage: false,
    showBlank: false
  }),
  computed: {
    srcImage() {
      let field = this.getDataSourceField(this.model.ImageUrl)
      if (!field || field.startsWith('http://') || field.startsWith('https://')) {
        return field
      }

      let origin = window.location.origin
      let url = new URL(this.$router.options.base, origin.replace(/^\//))
      let result = new URL(field, url)
      return result.href
    }
  },
  watch: {
    // При изменении ссылки, пытаться снова загружать основную картинку
    srcImage: function() {
      this.needDefaultImage = false
    }
  },
  methods: {
    load() {
      this.needDefaultImage = false
    },
    error() {
      this.needDefaultImage = true
    }
  }
}
</script>

<style>
.dr-image_plug {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #333;
}
</style>
